export function flash(message, level, important, withDatetime) {
  window.events.$emit("flash", message, level, important, withDatetime);
}

let errorTranslations = {};

export function setErrorTranslations(data) {
  errorTranslations = data;
}
export function handleNonValidationError(error) {
  if (error.response && error.response.status == 422) {
    return;
  }
  if (error.response) {
    return flashAxiosError(error.response);
  }
  flash(error.message, "error", true);
}
export function handleAxiosError(error) {
  if (error.response) {
    return flashAxiosError(error.response);
  }
  flash(error.message, "error", true);
}

function flashAxiosError(response) {
  let message = response.data.message || response.data.msg,
    status = response.status;

  if (status == 401) {
    //dealt in App.vue
    return;
  }
  if (response.data.errors) {
    for (const error in response.data.errors) {
      flash(response.data.errors[error][0], "error", true);
    }
    if (!message) {
      return;
    }
  }

  if (!message || message == "Server Error") {
    if (status in errorTranslations) {
      message = errorTranslations[status];
    } else {
      message = errorTranslations[500];
    }
  }

  //    if (status !== 422) {
  flash(message, "error", true);
  //    }
}

/*global ga, dataLayer*/
export function dispatchGoogleAnalyticsEvents(initialData) {
  // ga and gaTrack function are loaded by public/vendor/pumpup-4.min.js

  if (initialData.admin) {
    return;
  }
  var gaTrack = window["google_analytics_track"];
  if (!gaTrack) {
    console.log("missing gaTrack");
    return;
  }

  // get Cookie choices
  var get = function (name) {
    return document.cookie
      .split(";")
      .map((item) => {
        var parts = item.split("=");
        return { key: parts[0].trim(), val: parts[1] };
      })
      .find(({ key, val }) => {
        return key === name && val;
      });
  };

  // Setup tracking
  const gaID = "UA-20263930-1";
  if (get("_rc_track_user") || get("_rc_track") || !get("_rc_decision")) {
    window["ga-disable-" + gaID] = false;
    gaTrack({ property_id: gaID, user_id: initialData.user.id });
  } else {
    window["ga-disable-" + gaID] = true;
    console.log("tracking is disabled");
    return;
  }

  // prepare invoice events
  const eventsData = initialData.ga;
  const eventsByType = {};
  for (let i in eventsData) {
    const event = eventsData[i];
    if (eventsByType[event.type] == undefined) {
      eventsByType[event.type] = [];
    }
    eventsByType[event.type].push(event);
  }

  // send invoice events
  for (let type in eventsByType) {
    ga("require", type);
    for (let i in eventsByType[type]) {
      const event = eventsByType[type][i];
      ga(type + ":" + event.action, event.data);

      // GTM tracking
      // https://app.frontapp.com/open/cnv_8x4mhqc
      // https://ranchcomputing.slack.com/archives/D02KFE2NCCD/p1662024922114299
      // Rahma: Donc pour revenir au sujet des pixels FCB, Oui, on n'est pas bon avec tout ça et ceci est un manquement de base (ce n'est pas le pixel fcb qui changera les choses), je vais attendre la mise en ligne du nouveau site, et on basculera vers GA4  car la config actuelle de GA est loin d'être bonne. Tu peux donc continuer la configuration et on mettra entre parenthèse cette histoire de RGPD,  qui sera donc reportée à l'après refonte (il y aura un vrai module CookieBot + GA4)
      if (event.action == "addTransaction") {
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            value: event.data.revenue,
          },
        });
      }
    }
    ga(type + ":send");
  }
}
